var _style, _defs, _clipPath, _g, _defs2, _clipPath2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCognizantLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 245.8 44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#000048}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M59.2 2.7h186.7v40.8H59.2z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127012036145008233160000001695259364950843821_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000127012036145008233160000001695259364950843821_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170270455349886588150000003192033147480456075_",
    d: "M59.2 2.7h186.7v40.8H59.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034067840273054451910000013916040066528049284_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170270455349886588150000003192033147480456075_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000034067840273054451910000013916040066528049284_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.7 10.7h3.7v22.1h-3.7V10.7zm-13.5-.5c-2.4 0-4.6.8-6.4 2.3v-1.8h-3.7v22.1h3.7V20.3c0-3.6 2.9-6.4 6.4-6.4s6.4 2.9 6.4 6.4v12.5h3.7V20.3c0-5.6-4.5-10.1-10.1-10.1m-17.5.4h3.7v21.3c-.1 6.3-5.2 11.4-11.5 11.5-5 .1-9.6-3.2-11-8h4c1.3 2.7 4 4.4 7 4.3 4.3-.1 7.7-3.6 7.9-7.9V30c-4.7 4.3-12 4.1-16.3-.6-4.3-4.7-4.1-12 .6-16.3 4.4-4.1 11.3-4.1 15.7 0l-.1-2.5zm0 11.1c0-4.3-3.5-7.9-7.8-7.9s-7.9 3.5-7.9 7.8 3.5 7.9 7.9 7.9c4.3 0 7.8-3.5 7.8-7.8m-57-7.9c3 0 5.8 1.8 7.1 4.5h3.9c-1.8-6.1-8.3-9.6-14.4-7.7-6.1 1.8-9.6 8.3-7.7 14.4s8.3 9.6 14.4 7.7c3.7-1.1 6.6-4 7.7-7.7h-3.9c-1.8 3.9-6.5 5.6-10.4 3.8-3.9-1.8-5.6-6.5-3.8-10.4 1.3-2.8 4-4.6 7.1-4.6m35.9 7.9c0 6.4-5.2 11.5-11.5 11.5-6.4 0-11.5-5.2-11.5-11.5s5-11.5 11.4-11.5 11.6 5.1 11.6 11.5m-3.7 0c0-4.3-3.5-7.9-7.8-7.9s-7.9 3.5-7.9 7.8 3.5 7.9 7.8 7.9c4.4 0 7.9-3.5 7.9-7.8m120.5-11.5c-2.4 0-4.6.8-6.4 2.3v-1.8h-3.7v22.1h3.7V20.3c0-3.6 2.9-6.5 6.4-6.5 3.6 0 6.5 2.9 6.5 6.4v12.5h3.7V20.3c-.1-5.6-4.6-10.1-10.2-10.1m-17.5.5h3.7v22.1h-3.7v-2.6c-4.7 4.3-12 4.1-16.3-.6-4.3-4.7-4.1-12 .6-16.3 2.1-2 4.9-3.1 7.8-3.1 2.9 0 5.7 1.1 7.9 3.1v-2.6zm0 11c0-4.3-3.5-7.8-7.9-7.8-4.3 0-7.8 3.5-7.8 7.9 0 4.3 3.5 7.8 7.8 7.8 4.4-.1 7.9-3.6 7.9-7.9m39.9-7.4v-3.7h-5.5v-6h-3.7v20.8c0 4.1 3.3 7.4 7.4 7.4h1.8v-3.7H244c-2 0-3.7-1.7-3.7-3.7V14.3h5.5zM160.5 2.7c-1.4 0-2.4 1.1-2.4 2.4 0 1.4 1.1 2.4 2.4 2.4 1.4 0 2.4-1.1 2.4-2.4.1-1.3-1-2.4-2.4-2.4.1 0 .1 0 0 0m24 8h-18.4v3.7h13.6l-13.6 14.7v3.7h18.4v-3.7h-13.7l13.6-14.7.1-3.7z"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085213138245146219190000008599264730915323836_",
    d: "M0 0h52.1v44H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023275576737302775000000017739223560985338244_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085213138245146219190000008599264730915323836_",
    overflow: "visible"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000023275576737302775000000017739223560985338244_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000050660665550895142240000014880732468509939883_",
    d: "m0 22 15.3 22 15.8-9.5L22.2 22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135667248469030152890000000337272502332585655_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050660665550895142240000014880732468509939883_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000135667248469030152890000000337272502332585655_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182500455220199611780000011285939690309641648_",
    gradientUnits: "userSpaceOnUse",
    x1: -391.039,
    y1: 277.815,
    x2: -390.039,
    y2: 277.815,
    gradientTransform: "matrix(31.1065 0 0 -21.9795 12163.862 6139.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d54ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35cacf"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000182500455220199611780000011285939690309641648_)",
    d: "M0 22h31.1v22H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114070949333990582630000017270483092055787688_",
    d: "M15.3 44h21.8l15-22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092426726985261628360000008018755475207643524_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114070949333990582630000017270483092055787688_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000092426726985261628360000008018755475207643524_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029744234580894563620000004719264263002787256_",
    gradientUnits: "userSpaceOnUse",
    x1: -393.062,
    y1: 277.815,
    x2: -392.062,
    y2: 277.815,
    gradientTransform: "matrix(36.8476 0 0 -21.9795 14498.684 6139.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279698"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000029744234580894563620000004719264263002787256_)",
    d: "M15.3 22h36.8v22H15.3z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124156495544010432790000012960116144518489730_",
    d: "M15.3 0 0 22h22.2l8.9-12.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029046943914045948290000010502153975593422010_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124156495544010432790000012960116144518489730_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000029046943914045948290000010502153975593422010_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031913817338843176650000007177461719868006072_",
    gradientUnits: "userSpaceOnUse",
    x1: -391.049,
    y1: 277.815,
    x2: -390.049,
    y2: 277.815,
    gradientTransform: "matrix(31.1316 0 0 -21.9796 12173.976 6117.246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f96a9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000031913817338843176650000007177461719868006072_)",
    d: "M0 0h31.1v22H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147909067435365521700000017294411540867699616_",
    d: "m15.3 0 36.8 22-15-22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078011445600416747300000013195656224370321068_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147909067435365521700000017294411540867699616_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000078011445600416747300000013195656224370321068_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128475501832932076910000005979470219009375159_",
    gradientUnits: "userSpaceOnUse",
    x1: -393.062,
    y1: 277.815,
    x2: -392.062,
    y2: 277.815,
    gradientTransform: "matrix(36.8476 0 0 -21.9796 14498.684 6117.246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b62ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93dfe3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000128475501832932076910000005979470219009375159_)",
    d: "M15.3 0h36.8v22H15.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognizantLogo);
export default __webpack_public_path__ + "static/media/cognizant-logo.2d5ddfcd0de3e776f2a2d3e2e58b5837.svg";
export { ForwardRef as ReactComponent };